export default __webpack_public_path__ + "static/tug-of-war-606dbe1b4fff9d6c3ae997dd94929b7d.png";